import React, { useState, useEffect } from 'react';
import '../../css/home.css';
import PlaceholderLoading from 'react-placeholder-loading';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaArrowRightLong } from "react-icons/fa6";
import ImgVerParceirosSvg from '../../assets/svg/iconVerParceiros.svg';
import ImgGanharSaldoSvg from '../../assets/svg/iconGanharSaldo.svg';
import ImgGastarSaldoSvg from '../../assets/svg/iconGastarSaldo.svg';
import ImgVerMovimentosSvg from '../../assets/svg/iconVerMovimentos.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setStatusCarteira, setCategoryState } from '../../features/onboardingData/onboardingUserData';
import Slider from '../../components/Sliders/Slider';
import CustomButton from '../../components/CustomButton';
import adsOfferData from '../../mock/adsOffer.json'
import adsSecondOfferData from '../../mock/adsSecondOffer.json'
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import Heading from '../../components/Heading';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import GifAnim from '../../components/GifAnim';
import useCodes from '../../hooks/useCodes';
import CustomBreadcrumbs from '../../components/Breadcrumbs/CustomBreadcrumbs';

function Home() {

    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const isStatusCarteira = useSelector((state) => state.onboardingUserData.isStatusCarteira);
    const isCategoryState = useSelector((state) => state.onboardingUserData.isCategoryState);
    const dispatch = useDispatch();
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const [swiperIndexTwo, setSwiperIndexTwo] = useState(0);
    const [swiperInstanceTwo, setSwiperInstanceTwo] = useState(null);

    const { getImageAdsNum, getSecondImageAdsNum } = useCodes();

    const renderImageByItem = (item) => {
        const imageAdsNum =  getSecondImageAdsNum(item.imageUrl);
        return imageAdsNum;
    };

    useEffect(() => {
        const delay = setTimeout(() => {
        setIsLoading(false); 
        }, 1000); 
        return () => clearTimeout(delay); 
    }, []);

    const hadleBtnClickAddNow = () => {
        navigate('/configuracoes/associar-cartao/tipo-de-associacao');
    };

    const hadleBtnClickGoToContacts = () => {
        navigate('/configuracoes#contactMainContainer');
    };

    const hadleBtnClickKnowMore = () => {
        window.open('https://saude360.medis.pt/medis-carteira-virtual', '_blank');
    };

    const hadleBtnBoxVerParceiros = () => {
        navigate('/ganhar-saldo/parceiros/catalogo-de-parceiros');
    };

    const hadleBtnBoxEarnBalance = () => {
        navigate('/ganhar-saldo/convidar-amigos');
    };

    const hadleBtnBoxSpendBalance = () => {
        navigate('/gastar-saldo');
        //window.location.href='https://marketplace.medis.pt/gastar-saldo-carteira-virtual-medis';
    };

    const hadleBtnBoxViewMovements = () => {
        navigate('/movimentos');
    };

    const hadleBtnClickKnowMorePartners = () => {
        const category = "Alojamento e Viagens";
        dispatch(setCategoryState(true));
        navigate('/ganhar-saldo/parceiros/catalogo-de-parceiros', { state: {category} });
    };

    const handleSwiperSlideChangeTwo = (swiperTwo) => {
        setSwiperIndexTwo(swiperTwo.activeIndex);
    };

    const nextImageTwo = () => {
        if (swiperInstanceTwo !== null) {
            swiperInstanceTwo.slideNext();
        }
    };

    const prevImageTwo = () => {
        if (swiperInstanceTwo !== null) {
            swiperInstanceTwo.slidePrev();
        }
    };
    
  return (  
    <>
    <Header/> 
    { isLoading ? 
        <GifAnim />
    :
    <div className={ isTablet ? "mainViewContainerHomeSteps" : ( isMobile ? 'mainViewContainerHomeStepsTablet' : 'mainViewContainerHomeStepsMobile') }>
        <div className={ isTablet ? 'mainFirstViewContainerHomeSteps' : ( isMobile ? 'mainFirstViewContainerHomeStepsTablet' : 'mainFirstViewContainerHomeStepsMobile') }>
            { (isStatusCarteira === '0' || isStatusCarteira ===  '2') &&
                <div className={ isTablet ? 'doYouHaveLinkingCard' : ( isMobile ? 'doYouHaveLinkingCardTablet' : 'doYouHaveLinkingCardMobile') }>
                    <div className={ isTablet ? 'txtDoYouHaveLinkingCardContainer' : (isMobile ? 'txtDoYouHaveLinkingCardContainer' : 'txtDoYouHaveLinkingCardContainerMobile')}>
                        <div className={ isTablet ? 'txtBoldDoYouHaveLinkingCard' : 'txtBoldDoYouHaveLinkingCardMobile' }>
                            { isStatusCarteira === '2' ?
                                'A sua carteira encontra-se suspensa'
                                :
                                'Associe um cartão bancário e comece a acumular'
                            }
                        </div>
                        <div className='txtRegularDoYouHaveLinkingCard'>
                            { isStatusCarteira === '2' ?
                                'Decidimos suspender a sua carteira por suspeitas de atividade fraudulenta. Entre em contacto para resolver a sua situação.'
                                :
                                'Pode fazê-lo em segundos através do MULTIBANCO ou da app MB Way.'
                            }
                        </div>
                    </div>
                    <div className={ isTablet ? 'divBtnAddCardHomeSteps' : ( isMobile ? 'divBtnAddCardHomeStepsTablet' : 'divBtnAddCardHomeStepsMobile') }>
                        <CustomButton 
                            text={ isStatusCarteira === '2' ? 'Entrar em contacto' : 'Associar cartão'} 
                            color={'#fff'}
                            textColor={'#141414'}
                            hasArrow={ isStatusCarteira === '2' ? false : true }
                            iconColor={'#141414'}
                            hasShadowWithe
                            onPress={ isStatusCarteira === '2' ? hadleBtnClickGoToContacts : hadleBtnClickAddNow } 
                        />
                    </div>
                </div>
            }
            <div className='mainHeadingViewContainerHomeSteps'>           
                <CustomBreadcrumbs hasBtnBack={false} />
                <div className={ isTablet ? 'titleSaldoContainerHomeSteps' : ( isMobile ? 'titleSaldoContainerHomeStepsTablet' : 'titleSaldoContainerHomeStepsMobile')}>
                    <Heading hasBtnBack={false} />
                </div>
            </div>
            <div className={ isTablet ? 'infoNavContainerHomeSteps' : ( isMobile ? 'infoNavContainerHomeStepsTablet' : 'infoNavContainerHomeStepsMobile')}>
                <div className={ isTablet ? 'txtInfoNavStepsContainerHomeSteps' : ( isMobile ? 'txtInfoNavStepsContainerHomeStepsTablet' : 'txtInfoNavStepsContainerHomeStepsMobile')}>
                    <div className='firstTxtInfoNavViewHomeSteps'>
                        <div className='textTitleRegularInfoNavHomeSteps'>Faça compras e acumule dinheiro.<br />Receba de volta uma percentagem do valor que gastou.</div>      
                    </div>
                    <div className={ isTablet ? 'btnKnowMoreViewHomeSteps' : ( isMobile ? 'btnKnowMoreViewHomeSteps' : 'btnKnowMoreViewHomeStepsMobile')}>
                        <CustomButton 
                            text={'Saber mais'} 
                            textColor={'#141414'}
                            borderColor={'#141414'}
                            onPress={hadleBtnClickKnowMore} 
                            hasShadow={false}
                        />
                    </div>
                </div>
                <div className='navBoxMainViewContainerHomeStepsMobile'>
                    <div className={ isTablet ? 'navBoxMainViewContainerHomeSteps' : 'navBoxMainViewContainerHomeStepsMobile' }>
                        <button className={ isTablet ? 'navBoxViewContainerHomeSteps' : 'navBoxViewContainerHomeStepsMobile' } onClick={hadleBtnBoxVerParceiros}>
                            <div className={isTablet ? 'navInnerContentContainerHomeSteps' : 'navInnerContentContainerHomeStepsMobile'}>
                                <img src={ImgVerParceirosSvg} alt="imagem" className={isTablet ? 'imagemNavBoxSvgHomeSteps' : ( isMobile ? 'imagemNavBoxSvgHomeSteps' : 'imagemNavBoxSvgHomeStepsMobile' )} />
                                <div className='txtNavBoxTitleViewContainerHomeSteps'>
                                    <div className='txtNavBoxTitleHomeSteps'>Ver parceiros</div>
                                </div>
                                <div className='txtNavBoxViewContainerHomeSteps'>
                                    <div className='txtNavBoxRegularHomeSteps'>Faça compras <br/>e acumule saldo</div>
                                </div>
                            </div>
                            <div className='arrowIconNavBoxViewContainerHomeSteps'>
                                <FaArrowRightLong className='arrowIconNavBoxHomeSteps' /> 
                            </div>
                        </button>

                        <button className={ isTablet ? 'navBoxViewContainerHomeSteps' : 'navBoxViewContainerHomeStepsMobile' } onClick={hadleBtnBoxEarnBalance}>
                            <div className={isTablet ? 'navInnerContentContainerHomeSteps' : 'navInnerContentContainerHomeStepsMobile'}>
                                <img src={ImgGanharSaldoSvg} alt="imagem" className={isTablet ? 'imagemNavBoxSvgHomeSteps' : ( isMobile ? 'imagemNavBoxSvgHomeSteps' : 'imagemNavBoxSvgHomeStepsMobile' )} />
                                <div className='txtNavBoxTitleViewContainerHomeSteps'>
                                    <div className='txtNavBoxTitleHomeSteps'>Ganhar saldo</div>
                                </div>
                                <div className='txtNavBoxViewContainerHomeSteps'>
                                    <div className='txtNavBoxRegularHomeSteps'>Convide amigos <br/>e ative ofertas</div>
                                </div>
                            </div>
                            <div className='arrowIconNavBoxViewContainerHomeSteps'>
                                <FaArrowRightLong className='arrowIconNavBoxHomeSteps' /> 
                            </div>
                        </button>

                    </div>
                    <div className={ isTablet ? 'navBoxMainViewContainerHomeSteps' : 'navBoxMainViewContainerHomeStepsMobile' }>
                        <button className={ isTablet ? 'navBoxViewContainerHomeSteps' : 'navBoxViewContainerHomeStepsMobile' } style={{ opacity: isStatusCarteira === '2' && 0.42 }} onClick={hadleBtnBoxSpendBalance} disabled={isStatusCarteira === '2'}>
                            <div className={isTablet ? 'navInnerContentContainerHomeSteps' : 'navInnerContentContainerHomeStepsMobile'}>
                                <img src={ImgGastarSaldoSvg} alt="imagem" className={isTablet ? 'imagemNavBoxSvgHomeSteps' : ( isMobile ? 'imagemNavBoxSvgHomeSteps' : 'imagemNavBoxSvgHomeStepsMobile' )} />
                                <div className='txtNavBoxTitleViewContainerHomeSteps'>
                                    <div className='txtNavBoxTitleHomeSteps'>Gastar saldo</div>
                                </div>
                                <div className='txtNavBoxViewContainerHomeSteps'>
                                    <div className='txtNavBoxRegularHomeSteps'>Receba o valor ou use-o <br/>no Marketplace Médis</div>
                                </div>
                            </div>
                            <div className='arrowIconNavBoxViewContainerHomeSteps'>
                                <FaArrowRightLong className='arrowIconNavBoxHomeSteps' /> 
                            </div>
                        </button>
                        
                        <button className={ isTablet ? 'navBoxViewContainerHomeSteps' : 'navBoxViewContainerHomeStepsMobile' } onClick={hadleBtnBoxViewMovements}>
                            <div className={isTablet ? 'navInnerContentContainerHomeSteps' : 'navInnerContentContainerHomeStepsMobile'}>
                                <img src={ImgVerMovimentosSvg} alt="imagem" className={isTablet ? 'imagemNavBoxSvgHomeSteps' : ( isMobile ? 'imagemNavBoxSvgHomeSteps' : 'imagemNavBoxSvgHomeStepsMobile' )} />
                                <div className='txtNavBoxTitleViewContainerHomeSteps'>
                                    <div className='txtNavBoxTitleHomeSteps'>Ver movimentos</div>
                                </div>
                                <div className='txtNavBoxViewContainerHomeSteps'>
                                    <div className='txtNavBoxRegularHomeSteps'>Acompanhe onde <br/>e quanto acumula</div>
                                </div>
                            </div>
                            <div className='arrowIconNavBoxViewContainerHomeSteps'>
                                <FaArrowRightLong className='arrowIconNavBoxHomeSteps' /> 
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div className={ isTablet ? 'mainSecondViewContainerHomeSteps' : ( isMobile ? 'mainSecondViewContainerHomeStepsTablet' : 'mainSecondViewContainerHomeStepsMobile') }>
            <div className='firstSubMainContainerHomeSteps'>
                <div className='secondTitleViewHomeSteps'>
                    { isLoading ? <PlaceholderLoading shape="rect" width={350} height={75}/> : (
                    <>
                        <span className={ isTablet ? 'thirdTextTitleRegular400HomeSteps' : 'textTitleBold700HomeStepsMobile'}>Parceiros </span> 
                        <span className={ isTablet ? 'thirdTextTitleRegular400HomeSteps' : 'textTitleRegular400HomeStepsMobile'}><b>Carteira Virtual</b></span>      
                    </>
                    )}
                </div>
                <div className={ isTablet ? 'txtSecondTitleViewHomeSteps' : (isMobile ? 'txtSecondTitleViewHomeSteps' : 'txtSecondTitleViewHomeStepsMobile')}>
                    { isLoading ? <PlaceholderLoading shape="rect" width={350} height={75}/> : (
                    <>
                        <span className={ isTablet ? 'textSecondTitleViewHomeSteps' : 'textSecondTitleViewHomeStepsMobile' }>Conheça alguns dos serviços ou lojas em que acumula saldo por cada compra.</span>
                    </>
                    )}
                </div>
            </div>

            {/* Start slider */}
            <Slider
                listRespData={adsOfferData.offerAds}
                getImage={getImageAdsNum}
            />
            {/* End slider */}

        </div>
        <div className={ isTablet ? 'navToAddNewCardViewContainerHome' : ( isMobile ? 'navToAddNewCardViewContainerHomeTablet' : 'navToAddNewCardViewContainerHomeMobile') }>
            <div className={ isTablet ? 'navToAddNewCardHome' : ( isMobile ? 'navToAddNewCardHomeTablet' : 'navToAddNewCardHomeMobile') }>
                <div className={ isTablet ? 'txtDoYouHaveLinkingCardContainer' : (isMobile ? 'txtNavToAddNewCardHomeContainerTablet' : 'txtNavToAddNewCardHomeContainerTablet')}>
                    <div className={ isTablet ? 'txtBoldNavToAddNewCardHome' : 'txtBoldDoYouHaveLinkingCardMobile' }>
                        Associar mais um cartão à sua Carteira Virtual Médis
                    </div>
                    <div className='txtRegularDoYouHaveLinkingCard'>
                        <span className='txtRegularDoYouHaveLinkingCard'>Pode adicionar até ao máximo de 5 cartões, através da app</span>
                        <span className='txtSemiBoldNavToAddNewCardHome'> MB WAY</span>
                        <span className='txtRegularDoYouHaveLinkingCard'> ou do</span>
                        <span className='txtSemiBoldNavToAddNewCardHome'> MULTIBANCO.</span>
                    </div>
                </div>
                <div className={ isTablet ? 'divBtnAddCardHomeSteps' : ( isMobile ? 'divBtnAddCardHomeStepsTablet' : 'divBtnAddCardHomeStepsMobile') }>
                    <CustomButton 
                        text={'Associar novo cartão'} 
                        color={'#fff'}
                        textColor={'#141414'}
                        hasArrow
                        iconColor={'#141414'}
                        hasShadowWithe
                        onPress={hadleBtnClickAddNow} 
                    />
                </div>
            </div>
        </div>
        <div className={ isTablet ? 'mainThirdViewContainerHomeSteps' : ( isMobile ? 'mainThirdViewContainerHomeStepsTablet' : 'mainSecondViewContainerHomeStepsMobile') }>
            <div className='thirdTitleViewContainerHomeSteps'>
                <div className='thirdTitleViewHomeSteps'>
                    { isLoading ? <PlaceholderLoading shape="rect" width={350} height={75}/> : (
                    <>
                        <div className={ isTablet ? 'thirdTextTitleRegular400HomeSteps' : ( isMobile ? 'thirdTextTitleRegular400HomeStepsTablet' : 'thirdTextTitleRegular400HomeStepsMobile') }>Próximo destino:</div>
                        <div className={ isTablet ? 'thirdTextTitleBold700HomeSteps' : ( isMobile ? 'thirdTextTitleBold700HomeStepsTablet' : 'thirdTextTitleBold700HomeSteps') }>hotel parceiro Carteira Virtual</div> 
                    </>
                    )}
                </div>
                <div className='txtThirdTitleViewHomeSteps'>
                    { isLoading ? <PlaceholderLoading shape="rect" width={350} height={75}/> : (
                    <>
                        <div className='thirdTextOneHomeSteps'>Vá de férias ou de fim-de-semana e receba até 15% de volta em saldo Carteira Virtual.</div>
                    </>
                    )}
                </div>
                <div className='txtFourTitleViewHomeSteps'>
                    { isLoading ? <PlaceholderLoading shape="rect" width={350} height={75}/> : (
                    <>
                        <div className='thirdTextTwoHomeSteps'>Conheça os parceiros de Alojamento e Viagens onde recebe cashback.</div>
                    </>
                    )}
                </div>
                <div className={ isTablet ? 'divBtnKnowMorePartnersHomeSteps' : ( isMobile ? 'divBtnKnowMorePartnersHomeSteps' : 'divBtnKnowMorePartnersHomeStepsMobile')}>
                    { isLoading ? <PlaceholderLoading shape="rect" width={150} height={20}/> : (
                        <>
                        <CustomButton 
                            text={'Ver parceiros de Alojamento'} 
                            textColor={'#00214D'}
                            borderColor={'#00214D'}
                            onPress={hadleBtnClickKnowMorePartners} 
                            hasShadow={false}
                            hasArrow={!isMobile}
                            iconColor={'#00214D'}
                        />
                        </>
                    )}
                </div>
            </div>
            
            <div className={ isTablet ? 'secondSliderAdsContainerHomeSteps' : ( isMobile ? 'secondSliderAdsContainerHomeStepsTablet' : 'secondSliderAdsContainerHomeStepsMobile') }>
                <Swiper
                    onSlideChange={(swiperTwo) => handleSwiperSlideChangeTwo(swiperTwo)}
                    onSwiper={(swiperTwo) => setSwiperInstanceTwo(swiperTwo)}
                    slidesPerView={ isTablet ? 2.1 : ( isMobile ? 1.2 : 1 ) }
                    spaceBetween={32}
                    style={{ background: 'transparent' }}
                    // pagination={{
                    //     clickable: true,
                    //   }}
                    modules={[Pagination]}
                    className={ isTablet ? "mySwiperTwo" : ( isMobile ? "mySwiperTwoTablet" : "mySwiperTwoMobile")}
                >
                {adsSecondOfferData.secondOfferAds.map((item, index) => (
                <SwiperSlide  key={index} >
                    { isLoading ? <PlaceholderLoading shape="rect" width={316} height={217}/> : (
                        <>
                        <div className={ isTablet ? 'secondSliderAdsOferta' : ( isMobile ? 'secondSliderAdsOfertaTablet' : 'secondSliderAdsOfertaMobile') } style={{ backgroundImage: `${ isTablet ? `url(${renderImageByItem(item)?.img.desktop})` : ( isMobile ? `url(${renderImageByItem(item)?.img.tablet})` : `url(${renderImageByItem(item)?.img.mobile})` ) }`, backgroundSize: 'cover', backgroundPosition: 'center' }} >
                        
                            {/* <img src={ad.imageUrl} alt="imagem"  className='imgAdsHomeStepsTwo' /> 
                            <div className='imgTitleAdsOfferTwoHomeStepsTwo'>{item.description}</div>  */}
                                            
                        </div>
                    </>
                    )}      
                </SwiperSlide>
                ))} 
                </Swiper>

                <div className={ isTablet ? 'thirdSubMainContainerCircleNavHomeSteps' : ( isMobile ? 'thirdSubMainContainerCircleNavHomeStepsTablet' : 'thirdSubMainContainerHomeStepsMobile') }>
                    { isLoading ? <PlaceholderLoading shape="rect" width={350} height={24}/> : (
                        <>
                        <button className='iconArrowLeftViewContainerCircleNavHomeSteps' onClick={prevImageTwo} disabled={ swiperIndexTwo == 0}>
                            <FaArrowLeftLong className='iconArrowCircleNavHomeSteps' /> 
                        </button>

                        <div className='cirlceSelectedNavHomeSteps'>
                            <div className='circleMainvViewNavHomeSteps'>
                                <div className='circleContainerNavHomeSteps'>
                                    <div className={ swiperIndexTwo == 0 ? 'circleSelectedViewNavHomeSteps' : 'circleViewNavHomeSteps'} />
                                </div>
                                <div className='circleContainerNavHomeSteps'>
                                    <div className={ swiperIndexTwo == 1 ? 'circleSelectedViewNavHomeSteps' : 'circleViewNavHomeSteps'} />
                                </div>
                                <div className='circleContainerNavHomeSteps'>
                                    <div className={ swiperIndexTwo >= 2 ? 'circleSelectedViewNavHomeSteps' : 'circleViewNavHomeSteps'} />
                                </div>
                            </div>
                        </div>

                        <button className='iconArrowRightViewContainerCircleNavHomeSteps' onClick={nextImageTwo} disabled={ swiperIndexTwo >= adsSecondOfferData.secondOfferAds.length - 2 }>
                            <FaArrowRightLong className='iconArrowCircleNavHomeSteps' /> 
                        </button>
                        </>
                    )}
                </div>
                <div className='pilinha'>

                </div>
            </div>
        </div>
    </div>
    }
    <Footer/> 
    </>
  )
}

export default Home;